import React from 'react';
import Loader from 'react-loader-spinner';

export const MainLoader = () => (
	<Loader height={10} type='ThreeDots' color='#fff' />
);
